/** Palette colors at an alpha. Fallbacks are the classic night palette. */
export function themeAlpha(cssVar: string, alpha: number, fallback: string): string {
  const percent = Math.round(alpha * 100);
  return `color-mix(in srgb, var(${cssVar}, ${fallback}) ${percent}%, transparent)`;
}

export const pageBg = (alpha: number) => themeAlpha('--chakra-colors-bg', alpha, '#0F0B1A');
export const elevatedBg = (alpha: number) =>
  themeAlpha('--chakra-colors-bg-elevated', alpha, '#1A1626');
export const surfaceBg = (alpha: number) => themeAlpha('--chakra-colors-surface', alpha, '#221C32');

/**
 * Type on a hero wash. The art dissolves into the page, so daylight uses ink
 * and night stays white.
 */
export const heroInk = { base: 'text', _dark: 'white' } as const;
export const heroInkMuted = { base: 'textMuted', _dark: 'whiteAlpha.800' } as const;
export const heroInkStrong = { base: 'text', _dark: 'whiteAlpha.900' } as const;
export const heroInkShadow = { base: 'none', _dark: '0 2px 14px rgba(0,0,0,0.45)' } as const;

/**
 * Control fill on a panel. Page paper, not an ink wash — mixing `text` into
 * parchment reads as gray. Hover uses the next warm step.
 */
export const fieldFill = 'bg';
export const fieldFillHover = 'surface';

/**
 * Menus sit on the same paper as fields in daylight. At night `bg` is the page,
 * so the panel steps up to `surface` to stay visible.
 */
export const dropdownBg = { base: 'bg', _dark: 'surface' } as const;

/** Card lift. Night is deep; daylight is a soft ink-tinted pair. */
export const raisedShadow = 'var(--riftbound-shadow-raised, 0 12px 34px rgba(0, 0, 0, 0.18))';

/** Text sitting on a cover. Dropped in daylight, where the scrim does the work. */
export const textLiftShadow =
  'var(--riftbound-shadow-text, 0 1px 10px rgba(0, 0, 0, 0.9), 0 1px 2px rgba(0, 0, 0, 0.8))';

/** Full-bleed hero: art dissolves into the page background. */
export const HERO_COVER_WASH = `linear-gradient(180deg, ${pageBg(0.1)} 0%, ${pageBg(0.48)} 58%, ${pageBg(0.98)} 100%)`;

/** Bottom frost on that same hero. */
export const HERO_COVER_BLUR = `linear-gradient(180deg, transparent 0%, ${pageBg(0.94)} 72%)`;
